// sx style objects shared by InvoicePreview, InvoiceCard and InvoiceItemsTable.

const paperSx = {
  boxShadow: '0px 3px 6px #0000001A',
  padding: '50px 48px 32px',
};

const textColorSx = {
  color: 'text.subtitle',
};

const invoiceCardContainerSx = {
  backgroundColor: '#F9F9F9',
  maxWidth: 250,
  padding: '16px 24px',
  width: '100%',
};

const listItemSx = (theme) => ({
  width: '100%',
  padding: '0 4px 0 0',
  borderBottom: `1px solid ${theme.palette.dividers.primary}`,

  '&:last-child': {
    border: 0,
    '& .MuiListItemText-secondary': {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
});

// Class name used where a className string is required (react-router <Link>,
// getDynamicLink). Its styles are defined by linkHostSx on an enclosing element.
const linkClassName = 'invoice-link';

const linkHostSx = {
  [`& .${linkClassName}`]: {
    fontWeight: 500,
    color: 'primary.main',
  },
};

const listTextSx = (theme) => ({
  display: 'flex',
  textAlign: 'right',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& .MuiListItemText-primary': {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
    wordBreak: 'break-word',
  },
  '& .MuiListItemText-secondary': {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    wordBreak: 'break-word',
  },
});

export {
  paperSx,
  textColorSx,
  invoiceCardContainerSx,
  listItemSx,
  linkClassName,
  linkHostSx,
  listTextSx,
};
